import { Component, HostListener, OnInit, ViewChild, ElementRef, DoCheck } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { AlertComponent } from '../alert/alert.component';
import { ArticleService } from '../services/article.service';
import { MeasureScreenSize } from "../core/utilities/screenDetector";
import { C } from '@angular/core/src/render3';
import { isArray } from 'util';
import { DomSanitizer, SafeResourceUrl, SafeStyle } from '@angular/platform-browser';
import { AppConstants } from '../app_setting/app-constants';
import * as firebase from 'firebase';

@Component({
  selector: 'app-article',
  templateUrl: './article.component.html',
  styleUrls: ['./article.component.css']
})
export class ArticleComponent implements OnInit, DoCheck {

  userProfile = JSON.parse(localStorage.getItem("user-profile"));
  userId = this.userProfile.customer_code;
  listArticles: any [] = [];
  storedArticles: any[] = [];
  title: string = '';
  startDate: string = '';
  endDate: string = '';
  isCollapsed = false;
  isLoadArticles = true;
  screenSize = 0;
  allQuery: any;
  queryTag: any[] = [];
  queryPage = '';
  tagList: any[] = [];
  activePage = 0;
  allArticleLength = 0;
  articleLength: number[] = [];
  filterDisplay = 'none';

  @ViewChild("alertModal") alertModal: AlertComponent;
  @HostListener('window:resize', ['$event']) winResize(e){
    this.screenSize = e.target.innerWidth;
    if(this.screenSize <= 992){
      this.isCollapsed = true;
    } else {
      this.isCollapsed = false;
    }
  }

  constructor(
    public articleService: ArticleService,
    private router: Router,
    private route: ActivatedRoute,
    private sanitizer: DomSanitizer
  ) { }

  ngDoCheck(): void {
    this.activePage = Number(this.route.snapshot.queryParams.page);
  }

  ngOnInit() {
    this.collapseDeterminer();

    this.route.queryParams.subscribe(value => {

      if(!value.page || !value.row){
        this.qpAppender({page: 1, row: 12})
      }

      if(value.tags){
        this.queryTag = [];
        if(isArray(value.tags)){
          this.queryTag = value.tags
        } else if (typeof value.tags === 'string'){
          this.queryTag.push(value.tags);
        }
      }

      if(value.title){
        this.title = value.title;
      }

      if(value.startDate || value.endDate){
        this.startDate = value.startDate;
        this.endDate = value.endDate;
      }

      this.allQuery = value;
      const filter = new URLSearchParams(value as URLSearchParams);
      this.loadArticle(filter);
    })

  }

  collapseDeterminer(){
    this.screenSize = MeasureScreenSize();
    if(this.screenSize <= 992){
      this.isCollapsed = true;
    } else {
      this.isCollapsed = false;
    };
  }

  loadArticle(params: any){
    this.isLoadArticles = true;
    this.articleService.getListArticles(
      params,
      data => {
        this.isLoadArticles = false;
        this.listArticles = data;
        this.allArticleLength = data[0].totalArticle;
        this.pageUpdater(this.allArticleLength);
      },
      onError => {
        this.alertModal.show('Gagal', onError.message)
      })
  }

  filterByTitle(){
    let term = this.title;
    if(!term){
      term = null;
    }
    this.qpAppender({title: term, page: 1, row: 12});
  }

  async applyFilter(){

    if(this.startDate && this.endDate && this.queryTag.length > 0){
      if(this.queryTag.length === 1){
        this.router.navigate([],{
          relativeTo: this.route,
          queryParams: {
            startDate: this.startDate,
            endDate: this.endDate,
            tags: this.queryTag.toString(),
            page: 1,
            row: 12
          },
          queryParamsHandling: 'merge'
        })
      } else if(this.queryTag.length > 1){
        this.router.navigate([],{
          relativeTo: this.route,
          queryParams: {
            startDate: this.startDate,
            endDate: this.endDate,
            tags: this.queryTag,
            page: 1,
            row: 12
          },
          queryParamsHandling: 'merge'
        })
        this.router.onSameUrlNavigation = 'reload';
      }
    } else if(this.startDate && this.endDate && this.queryTag.length == 0){
      this.qpAppender({
        startDate: this.startDate,
        endDate: this.endDate,
        tags: null,
        page: 1,
        row: 12
      })
    } else if(!this.startDate && !this.endDate && this.queryTag.length > 0){
      if(this.queryTag.length === 1){
        this.router.navigate([],{
          relativeTo: this.route,
          queryParams: {
            startDate: null,
            endDate: null,
            tags: this.queryTag.toString(),
            page: 1,
            row: 12
          },
          queryParamsHandling: 'merge'
        })
        this.router.onSameUrlNavigation = 'reload';
      } else if(this.queryTag.length > 1){
        this.router.navigate([],{
          relativeTo: this.route,
          queryParams: {
            startDate: null,
            endDate: null,
            tags: this.queryTag,
            page: 1,
            row: 12
          },
          queryParamsHandling: 'merge',
        })

        this.router.onSameUrlNavigation = 'reload';
      }
    } else {
      this.clearQp();
    }
  }

  clearFilter(){
    this.title = '';
    this.startDate = '';
    this.endDate = '';
    this.queryTag = [];
    this.clearQp();
  }

  validateDate(){
    let sDate = new Date(this.startDate).getTime();
    let eDate = new Date(this.endDate).getTime();

    if(this.startDate && this.endDate){
      if(sDate > eDate){
        this.startDate = '';
        this.endDate = ''
      }
    }

  }

  appendTag(e: any){
    if(typeof e === 'string'){
      this.queryTag.push(e)
    } else if (isArray(e)){
      this.queryTag = e;
    }
  }

  goToArticle(article: any){
    firebase.analytics().logEvent('click_list_article');

    this.router.navigate(['/detail-artikel/', article.id]);
  }

  resetDFilter(){
    this.startDate = null;
    this.endDate = null;
    this.qpAppender(
      {
        startDate: this.startDate,
        endDate: this.endDate
      }
    )
  }

  qpAppender(params){
    this.router.navigate([], {
      relativeTo: this.route,
      queryParams: params,
      queryParamsHandling: 'merge',
    })
  }

  clearQp(){
    this.router.navigate([], {
      relativeTo: this.route,
      queryParams: {
        startDate: null,
        endDate: null,
        tags: null,
        title: null,
        page: 1
      },
      queryParamsHandling: 'merge'
    })
  }

  pageUpdater(total: number){

    this.articleLength = [];

    let divide = total / 12;
    let divided = Math.ceil(divide);

    for (let x = 0; x < divided; x++) {
      this.articleLength.push(x);
    }
  }

  prevPagination(){

    let pl = this.articleLength.length;
    let curr = this.activePage;

    if(this.activePage === 1){
      curr = pl;
      this.activePage = curr;
      this.router.navigate([], {
        relativeTo: this.route,
        queryParams: {
          page: curr
        },
        queryParamsHandling: 'merge'
      })
    } else {
      curr = curr - 1;
      this.activePage = curr;
      this.router.navigate([], {
        relativeTo: this.route,
        queryParams: {
          page: curr
        },
        queryParamsHandling: 'merge'
      })

    }


  }

  nextPagination(){

    let pl = this.articleLength.length;
    let curr = this.activePage;

    if(curr === pl){
      curr = 1;
      this.activePage = curr;
      this.router.navigate([], {
        relativeTo: this.route,
        queryParams: {
          page: curr
        },
        queryParamsHandling: 'merge'
      })
    } else {
      curr = curr + 1;
      this.activePage = curr;
      this.router.navigate([], {
        relativeTo: this.route,
        queryParams: {
          page: curr
        },
        queryParamsHandling: 'merge'
      })

    }

  }

  loadPage(i: number){

    this.activePage = i;
    this.router.navigate([], {
      relativeTo: this.route,
      queryParams: {
        page: i,
        row: 12
      },
      queryParamsHandling: 'merge'
    })
  }

  getThumbnail(url: string){
    if (url === null || url === '' || url === undefined){
      return `url(${AppConstants.NoImageDefault})`;
    }

    let sanitized: SafeStyle = this.sanitizer.bypassSecurityTrustStyle(`url(${url})`);

    return sanitized;
  }

  filterToggle(){
    if(this.filterDisplay === 'none'){
      this.filterDisplay = 'flex';
    } else {
      this.filterDisplay = 'none';
    }
  }

}
